module.exports = __webpack_public_path__ + "media/site/images/case_studies/eplanning/oee_2@2x-b45a6547d091e0ebffcad10d4fbd3f78.png";